import { createContext, useContext } from "react";

const BookEditorContext = createContext({
   
})

const BookEditorProvider = ({ children, editor }: { children: React.ReactNode, editor: any }) => {
    return (
        <BookEditorContext.Provider value={editor}>
            {children}
        </BookEditorContext.Provider>
    )
}

export const useBookEditor = () => {
    return useContext(BookEditorContext);
}   

export default BookEditorProvider;import { createContext, useContext } from "react";

const BookEditorContext = createContext({
   
})

const BookEditorProvider = ({ children, editor }: { children: React.ReactNode, editor: any }) => {
    return (
        <BookEditorContext.Provider value={editor}>
            {children}
        </BookEditorContext.Provider>
    )
}

export const useBookEditor = () => {
    return useContext(BookEditorContext);
}   

export default BookEditorProvider;